/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchSummary,
  KillswitchSummary$inboundSchema,
} from "./killswitchsummary.js";

export type KillswitchListResult = {
  items: Array<KillswitchSummary>;
  nextCursor?: string | undefined;
};

/** @internal */
export const KillswitchListResult$inboundSchema: z.ZodMiniType<
  KillswitchListResult,
  unknown
> = z.pipe(
  z.object({
    items: z.array(KillswitchSummary$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function killswitchListResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchListResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchListResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchListResult' from JSON`,
  );
}
